import React from "react";
import { useNavigate } from "react-router-dom";
import "./RegistrationSuccess.css";

const RegistrationSuccess = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    // Navigate to a desired page, for example, the homepage
    navigate("/");
  };

  return (
    <div className="registration-success-container">
      <h1 className="success-title">Registration Successful!</h1>
      <p className="success-message">
        Thank you for registering for GPACON 2025. Your registration has been successfully completed.
      </p>
      <button className="continue-button" onClick={handleContinue}>
        Continue to Home
      </button>
    </div>
  );
};

export default RegistrationSuccess;
